// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5702a144","455":"a2fd40a7","977":"02ed67e6"}[chunkId] + ".chunk.js";
};